import "core-js/modules/es.array.includes.js";
import EarTraining808Render from "@/components/subject/EarTraining808/EarTraining808Render";
import ThreeRender from "@/components/subject/ThreeProblem/ThreeRender";
import E808BRender from "@/components/subject/E808B/E808BRender";
import LogicalReasoningRender from "@/components/subject/LogicalReasoning/LogicalReasoningRender";
import OpticalPathInferenceRender from "@/components/subject/OpticalPathInference/OpticalPathInferenceRender.vue";
import FlashDiamondRender from "@/components/subject/FlashDiamond/FlashDiamondRender";
import ImageTransformRender from "@/components/subject/ImageTransform/ImageTransformRender";
import WhackAMoleRender from "@/components/subject/WhackAMole/WhackAMoleRender";
import E808APlusRender from "@/components/subject/E808APlus/E808APlusRender";
import MossRender from "@/components/subject/Moss/MossRender";
import E808EPlusRender from "@/components/subject/E808EPlus/E808EPlusRender";
import E808DRender from "@/components/subject/E808D/E808DRender";
import E808B2Render from "@/components/subject/E808B2/E808B2Render";
import E808CRender from "@/components/subject/E808C/E808CRender";
import QuickScaleRender from "@/components/subject/QuickScale/QuickScaleRender";
import E808D2Render from "@/components/subject/E808D2/E808D2Render";
import E808B3Render from "@/components/subject/E808B3/E808B3Render";
import CodeMathRender from "@/components/subject/CodeMath/CodeMathRender";
import FastMemoryRender from "@/components/subject/FastMemory/FastMemoryRender";
import SeesawRender from "@/components/subject/Seesaw/SeesawRender";
import { ElMessage } from "element-plus";
import BlockRotateRender from "@/components/subject/BlockRotate/BlockRotateRender";
import CubeComplementRender from "@/components/subject/CubeComplement/CubeComplementRender";
import FillWallRender from "@/components/subject/FillWall/FillWallRender";
import RandomForestRender from "@/components/subject/RandomForest/RandomForestRender.vue";
import BlackWhiteDotRender from "@/components/subject/BlackWhiteDot/BlackWhiteDotRender.vue";
import GroundPerspectiveRender from "@/components/subject/GroundPerspective/GroundPerspectiveRender.vue";
import PriceCalculateRender from "@/components/subject/PriceCalculate/PriceCalculateRender.vue";
import Unfolding3DRender from "@/components/subject/Unfolding3D/Unfolding3DRender.vue";
import FlashBoxRender from "../subject/FlashBox/FlashBoxRender.vue";
import DiceRender from "../subject/Dice/DiceRender.vue";
import NineGridRender from "../subject/NineGrid/NineGridRender.vue";
import LogicalReasoning2DRender from "@/components/subject/LogicalReasoning2d/LogicalReasoning2DRender.vue";
import TextLogicalReasoningRender from "@/components/subject/TextLogicalReasoning/TextLogicalReasoningRender.vue";
import PlaneTurntableRender from "@/components/subject/PlaneTurntable/PlaneTurntableRender.vue";
import StereoSameEdgeRender from "@/components/subject/StereoSameEdge/StereoSameEdgeRender.vue";
import GraphMatchRender from "@/components/subject/GraphMatch/GraphMatchRender.vue";
import CircuitRoutingRender from "@/components/subject/CircuitRouting/CircuitRoutingRender.vue";
import DigitSymbolReactionReview from "@/components/subject/DigitSymbolReaction/DigitSymbolReactionReview.vue";
import LogicalTransformer2D from "@/components/subject/LogicalTransformer2D/LogicalTransformer2D.vue";
import LogicalTransformerSectorRender from "@/components/subject/LogicalTransformerSector/LogicalTransformerSectorRender.vue";
import F3DScaleARender from "@/components/subject/F3DScaleA/F3DScaleARender.vue";
import F3DScaleBRender from "@/components/subject/F3DScaleA/F3DScaleBRender.vue";
import F3DScaleCRender from "@/components/subject/F3DScaleA/F3DScaleCRender.vue";
import TaiChiARender from "@/components/subject/TaiChi/TaiChiARender.vue";
import TaiChiBRender from "@/components/subject/TaiChi/TaiChiBRender.vue";
import StereoProjectionEditor from "@/components/subject/StereoProjection/StereoProjectionEditor.vue";
import StereoProjectionRender from "@/components/subject/StereoProjection/StereoProjectionRender.vue";
import KnotRender from "@/components/subject/Knot/KnotRender.vue";
import DNASequenceRender from "@/components/subject/DNASequence/DNASequenceRender.vue";
import ColorGridMemoryRender from "@/components/subject/ColorGridMemory/ColorGridMemoryRender.vue";
import ImageSequenceMemoryRender from "@/components/subject/ImageSequenceMemory/ImageSequenceMemoryRender.vue";
import ColorHeightProjectionRender from "@/components/subject/ColorHeightProjection/ColorHeightProjectionRender.vue";
import HanoiTowerInferenceRender from "@/components/subject/HanoiTowerInference/HanoiTowerInferenceRender.vue";
import NineGridMirrorInferenceRender from "@/components/subject/NineGridMirrorInference/NineGridMirrorInferenceRender.vue";
import MechanicalArmPoseRender from "@/components/subject/MechanicalArmPose/MechanicalArmPoseRender.vue";
import RobotArmBottleView from "@/views/RobotArmBottleView.vue";
import api from "@/api";
export default {
  name: "QuestionReviewRenderPage",
  components: {
    OpticalPathInferenceRender,
    EarTraining808Render,
    KnotRender,
    DNASequenceRender,
    ColorGridMemoryRender,
    ImageSequenceMemoryRender,
    ColorHeightProjectionRender,
    NineGridMirrorInferenceRender,
    HanoiTowerInferenceRender,
    MechanicalArmPoseRender,
    RobotArmBottleView,
    StereoProjectionRender,
    StereoProjectionEditor,
    TaiChiBRender,
    TaiChiARender,
    F3DScaleCRender,
    F3DScaleBRender,
    F3DScaleARender,
    LogicalTransformerSectorRender,
    LogicalTransformer2D,
    LogicalReasoning2DRender,
    TextLogicalReasoningRender,
    PlaneTurntableRender,
    StereoSameEdgeRender,
    GraphMatchRender,
    CircuitRoutingRender,
    DigitSymbolReactionReview,
    Unfolding3DRender,
    PriceCalculateRender,
    GroundPerspectiveRender,
    BlackWhiteDotRender,
    RandomForestRender,
    SeesawRender,
    FastMemoryRender,
    CodeMathRender,
    E808B3Render,
    E808D2Render,
    QuickScaleRender,
    E808CRender,
    E808B2Render,
    E808DRender,
    E808EPlusRender,
    E808BRender,
    MossRender,
    ThreeRender,
    FillWallRender,
    BlockRotateRender,
    CubeComplementRender,
    E808APlusRender,
    WhackAMoleRender,
    ImageTransformRender,
    FlashDiamondRender,
    LogicalReasoningRender,
    FlashBoxRender,
    DiceRender,
    NineGridRender
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return null;
      }
    },
    subject: {
      type: String,
      default: ''
    },
    jumpToIndex: {
      type: Number,
      default: 0
    },
    groupSize: {
      type: Number,
      default: 1
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    jumpToIndex(nv) {
      this.reviewIndex = nv;
    }
  },
  data() {
    return {
      reviewIndex: 0
    };
  },
  methods: {
    reGenerate(f, t) {
      this.$emit('reGenerate', f, t);
    },
    init() {},
    async handleSave() {
      const tplId = this.$route.params.tplId;
      if (this.subject === 'MechanicalArmPose' && this.editMode) {
        const saved = await this.$refs.mechanicalArmEditorRef?.commitScenario();
        if (!saved) return;
        try {
          await api.publishMechanicalArmPose(Number(tplId));
        } catch (error) {
          return;
        }
      }
      if (['BlockRotate', 'FillWall', 'CubeComplement', 'GroundPerspective', 'RandomForest'].includes(this.subject) && this.editMode) {
        if (!this.$refs.threeRenderRef.checkIsSaveAll()) {
          ElMessage.error('本题有未保存的图片，请检查');
          return;
        }
        await this.$refs.threeRenderRef.saveAll(tplId);
      }
      if (this.subject == 'RandomDice' && this.editMode) {
        if (!this.$refs.diceRenderRef.checkIsSaveAll()) {
          ElMessage.error('本题有未保存的图片，请检查');
          return;
        }
        await this.$refs.diceRenderRef.saveAll(tplId);
      }
      if (this.subject == 'NeuralNetwork' && this.editMode) {
        if (!this.$refs.neuralNetworkRef.checkIsSaveAll()) {
          ElMessage.error('本题未编辑完善，请检查');
          return;
        }
        this.$refs.neuralNetworkRef.saveAll(tplId);
      }
      if (this.subject == 'StereoscopicSectionExam' && this.editMode) {
        if (!this.$refs.StereoscopicSectionExamEditor.checkIsSaveAll()) {
          ElMessage.error('本题未编辑完善，请检查');
          return;
        }
        this.$refs.StereoscopicSectionExamEditor.saveAll(tplId);
      }
      if (this.subject == 'StereoProjection' && this.editMode) {
        if (!this.$refs.StereoProjectionEditor.checkIsSaveAll()) {
          ElMessage.error('本题未编辑完善，请检查');
          return;
        }
        this.$refs.StereoProjectionEditor.saveAll(tplId);
      }
      this.$router.go(-1);
    },
    handleNextNotSave() {
      this.reviewIndex++;
    },
    async handleNext() {
      if (this.subject === 'MechanicalArmPose' && this.editMode) {
        const saved = await this.$refs.mechanicalArmEditorRef?.commitScenario();
        if (!saved) return;
      }
      if (['BlockRotate', 'FillWall', 'CubeComplement', 'GroundPerspective', 'RandomForest'].includes(this.subject) && this.editMode) {
        if (!this.$refs.threeRenderRef.checkIsSaveAll()) {
          ElMessage.error('本题有未保存的图片，请检查');
          return;
        }
        this.$refs.threeRenderRef.saveAll(this.$route.params.tplId);
      }
      if (this.subject == 'RandomDice' && this.editMode) {
        if (!this.$refs.diceRenderRef.checkIsSaveAll()) {
          ElMessage.error('本题有未保存的图片，请检查');
          return;
        }
        this.$refs.diceRenderRef.saveAll(this.$route.params.tplId);
      }
      if (this.subject == 'NeuralNetwork' && this.editMode) {
        if (!this.$refs.neuralNetworkRef.checkIsSaveAll()) {
          ElMessage.error('本题未编辑完善，请检查');
          return;
        }
        this.$refs.neuralNetworkRef.saveAll(this.$route.params.tplId);
      }
      if (this.subject == 'StereoscopicSectionExam' && this.editMode) {
        if (!this.$refs.StereoscopicSectionExamEditor.checkIsSaveAll()) {
          ElMessage.error('本题未编辑完善，请检查');
          return;
        }
        this.$refs.StereoscopicSectionExamEditor.saveAll(this.$route.params.tplId);
      }
      if (this.subject == 'StereoProjection' && this.editMode) {
        if (!this.$refs.StereoProjectionEditor.checkIsSaveAll()) {
          ElMessage.error('本题未编辑完善，请检查');
          return;
        }
        this.$refs.StereoProjectionEditor.saveAll(this.$route.params.tplId);
      }
      this.reviewIndex++;
    }
  },
  mounted() {
    this.init();
  }
};